import React from "react";

export function ShareIcon(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 119.14 104.04"
      width="30"
      height="30"
      {...props}
    >
      <g>
        <rect className="cls-1" x="57.5" y="4.18" width="5" height="60.88" />
        <polygon
          className="cls-1"
          points="81.58 28.65 60 7.07 38.42 28.65 34.89 25.11 60 0 85.12 25.11 81.58 28.65"
        />
      </g>
      <path
        className="cls-1"
        d="m106.89,104.04H12.25c-6.98,0-12.25-3.41-12.25-7.94v-41.24c0-4.53,5.27-7.94,12.25-7.94h17.23v5H12.25c-4.43,0-7.25,1.93-7.25,2.94v41.24c0,1.01,2.82,2.94,7.25,2.94h94.64c4.43,0,7.25-1.93,7.25-2.94v-41.24c0-1.01-2.82-2.94-7.25-2.94h-16.25v-5h16.25c6.98,0,12.25,3.41,12.25,7.94v41.24c0,4.53-5.27,7.94-12.25,7.94Z"
      />
    </svg>
  );
}
